<template>
	<div class="centerWidth">
		<div class="gaokao-nav">
			<span @click="goMyCenter">个人中心 ></span>
			<span @click="goBack">新高考选科测评 ></span>
			<span>开始测试</span>
			<el-button type="primary" style="margin-left: 20px;display: none;" @click="ceshiOption()">选择</el-button>
		</div>
		<gk-testa @next="handleNext" v-show="tabId === 1" :question.sync="subjectLeval"></gk-testa>
		<gk-testb @next="handleNext" @prev="handlePrev" v-show="tabId === 2" :question.sync="subjectLevalInterest"></gk-testb>
		<gk-testc @next="handleNext" @prev="handlePrev" v-show="tabId === 3" :question.sync="careerInterest"></gk-testc>
		<gk-testd @prev="handlePrev" @submitEvalution="handleSubmit" v-show="tabId === 4" :question.sync="careerCharacter" :isSub.sync="noticeVisible"></gk-testd>
		<!-- 5.30 -->
		<div class="ptpopupTc flexCenter" v-show="isJiaIng">
			<div class="ptpotxt">
				<div class="ptadiva" id="myChartYuan"></div>
				<p>请稍等,正在为您生成报告...</p>
			</div>
		</div>
	</div>
</template>

<script>
import gkTesta from './gkTestA.vue';
import gkTestb from './gkTestB.vue';
import gkTestc from './gkTestC.vue';
import gkTestd from './gkTestD.vue';
export default {
	components: {
		gkTesta,
		gkTestb,
		gkTestc,
		gkTestd
	},
	data() {
		return {
			ratioTime: null,
			isJiaIng: false,
			tabId: 1,
			question: [],
			// 学科水平
			subjectLeval: [],
			// 学科兴趣
			subjectLevalInterest: [],
			// 职业兴趣
			careerInterest: [],
			// 职业性格
			careerCharacter: [],
			// 提交弹窗
			noticeVisible: false
		};
	},
	watch: {
		tabId() {
			document.querySelector('body').scrollTo(0, 0);
			window.scrollTo(0, 0);
		}
	},
	created() {
		this.getQuestion();
	},
	beforeDestroy() {
		if (this.ratioTime) {
			clearTimeout(this.ratioTime);
			this.ratioTime = null;
		}
	},
	mounted() {
		this.drawLineB(0);
	},
	methods: {
		drawLineB(nub) {
			var that = this;
			console.log('nub', nub);
			const myChart = this.$echarts.init(document.getElementById('myChartYuan'));
			myChart.setOption({
				color: ['#feb9a7', '#3171ff00'],
				tooltip: {
					trigger: 'item',
					show: false
				},
				graphic: {
					type: 'text',
					left: 'center',
					top: 'center',
					style: {
						text: nub + '%',
						textAlign: 'center',
						fill: '#7ac8fd',
						fontSize: 24
					}
				},
				legend: {
					top: '0%',
					left: 'center'
				},
				series: [
					{
						type: 'pie',
						radius: ['55%', '65%'],
						avoidLabelOverlap: false,
						hoverAnimation: false,
						label: {
							show: false,
							position: 'center'
						},
						emphasis: {
							label: {
								show: true,
								fontSize: '40',
								fontWeight: 'bold'
							}
						},
						labelLine: {
							show: true
						},
						data: [
							{
								value: nub,
								name: ''
							},
							{
								value: 100 - nub,
								name: ''
							}
						]
					}
				]
			});
			if (nub > 0 && nub < 100) {
				that.ratioTime = setTimeout(() => {
					var dd = nub;
					if (dd === 99) {
						dd = 99;
					} else if (dd > 80) {
						dd = dd + 1;
					} else if (dd > 60) {
						dd = dd + 5;
					} else {
						dd = dd + 10;
					}
					that.drawLineB(dd);
				}, 1000);
			} else {
				if (that.ratioTime) {
					clearTimeout(that.ratioTime);
					that.ratioTime = null;
				}
			}
		},
		// 个人中心
		goMyCenter() {
			this.$router.push('/myIndex');
		},
		// 返回上一级
		goBack() {
			this.$router.go(-1);
		},
		// 获取题目
		getQuestion() {
			this.$api.getEvaluationQuestion(this.$route.query).then(res => {
				const questionList = res.data.map(a => {
					a.Title = a.Title.replaceAll('##', '');
					a.Content = '';
					a.Option = '';
					a.OptionList = [];
					const arr = [];
					if (a.Type === 3 && a.AnswerCount > 1) {
						for (let i = 0; i < a.AnswerCount; i++) {
							arr.push('');
						}
						a.ContentList = arr;
					}
					a.notEmpty = true;
					return a;
				});
				this.question = questionList;
				this.subjectLeval = questionList.filter(a => a.Category === '学科水平');
				this.subjectLevalInterest = questionList.filter(a => a.Category === '学科兴趣');
				this.careerInterest = questionList.filter(a => a.Category === '职业兴趣');
				this.careerCharacter = questionList.filter(a => a.Category === '职业性格');
				console.log('下面是测试代码');
				
			});
		},
		ceshiOption(){
			if (this.subjectLeval.length > 0) {
				this.subjectLeval = this.subjectLeval.map(a => {
					if (a.AnswerList.length > 0) {
						a.Option = a.AnswerList[0].Option;
					}
					return a;
				});
			}
			if (this.subjectLevalInterest.length > 0) {
				this.subjectLevalInterest = this.subjectLevalInterest.map(a => {
					if (a.AnswerList.length > 0) {
						a.Option = a.AnswerList[0].Option;
					}
					return a;
				});
			}
			if (this.careerInterest.length > 0) {
				this.careerInterest = this.careerInterest.map(a => {
					if (a.AnswerList.length > 0) {
						a.Option = a.AnswerList[0].Option;
					}
					return a;
				});
			}
			if (this.careerCharacter.length > 0) {
				this.careerCharacter = this.careerCharacter.map(a => {
					if (a.AnswerList.length > 0) {
						a.Option = a.AnswerList[0].Option;
					}
					return a;
				});
			}
		},
		// 提交
		handleSubmit() {
			if (!this.validateModel()) {
				return;
			}
			const model = {
				EvaluationId: Number(this.$route.query.id),
				Key: this.$route.query.key
			};
			model.Question = [...this.subjectLeval, ...this.subjectLevalInterest, ...this.careerInterest, ...this.careerCharacter].map(a => {
				const obj = {
					QuestionId: a.Id,
					Type: a.Type,
					Content: a.Content,
					Option: a.Option
				};
				if (a.Type === 2) {
					obj.Option = a.OptionList.join(',');
				}
				if (a.Type === 3 && a.AnswerCount > 1) {
					a.Content = a.Id === 7 ? `${a.ContentList[0][1]},${a.ContentList[2]}` : a.ContentList.join(',');
				}
				return obj;
			});
			// const loading = this.$loading({
			// 	lock: true
			// });
			this.drawLineB(10);
			this.isJiaIng = true;
			this.$api.saveEvaluation(model).then(res => {
				this.noticeVisible = true;
				// loading.close();
				this.drawLineB(100);
				setTimeout(() => {
					this.isJiaIng = false;
					setTimeout(() => {
						this.drawLineB(0);
						this.$router.push('/report');
					}, 300);
				}, 500);
			});
		},
		// 下一步
		handleNext() {
			if (this.tabId < 4) {
				this.tabId += 1;
			}
		},
		// 上一步
		handlePrev() {
			if (this.tabId > 1) {
				this.tabId -= 1;
			}
		},
		// 检查是否有题目未完成
		validateModel() {
			const noticeArr = [];
			if (this.subjectLeval.some(a => !a.Content && !a.Option && a.OptionList.length === 0 && a.ContentList.length === 0)) {
				const emptyArr = this.subjectLeval.filter(a => !a.Content && !a.Option && a.OptionList.length === 0 && a.ContentList.length === 0);
				this.subjectLeval = this.subjectLeval.map(a => {
					a.notEmpty = !emptyArr.some(b => b.Id === a.Id);
					return a;
				});
				noticeArr.push('学科水平');
				// this.$util.showError('学科水平中有未完成的题目，请完成后提交');
				// return false;
			}
			if (this.subjectLevalInterest.some(a => !a.Content && !a.Option && a.OptionList.length === 0)) {
				const emptyArr = this.subjectLevalInterest.filter(a => !a.Content && !a.Option && a.OptionList.length === 0);
				this.subjectLevalInterest = this.subjectLevalInterest.map(a => {
					a.notEmpty = !emptyArr.some(b => b.Id === a.Id);
					return a;
				});
				// this.$util.showError('学科兴趣中有未完成的题目，请完成后提交');
				noticeArr.push('学科兴趣');
				// return false;
			}
			if (this.careerInterest.some(a => !a.Content && !a.Option && a.OptionList.length === 0)) {
				const emptyArr = this.careerInterest.filter(a => !a.Content && !a.Option && a.OptionList.length === 0);
				this.careerInterest = this.careerInterest.map(a => {
					a.notEmpty = !emptyArr.some(b => b.Id === a.Id);
					return a;
				});
				// this.$util.showError('职业兴趣中有未完成的题目，请完成后提交');
				noticeArr.push('职业兴趣');
				// return false;
			}
			if (this.careerCharacter.some(a => !a.Content && !a.Option && a.OptionList.length === 0)) {
				const emptyArr = this.careerCharacter.filter(a => !a.Content && !a.Option && a.OptionList.length === 0);
				this.careerCharacter = this.careerCharacter.map(a => {
					a.notEmpty = !emptyArr.some(b => b.Id === a.Id);
					return a;
				});
				// this.$util.showError('职业性格中有未完成的题目，请完成后提交');
				noticeArr.push('职业性格');
				// return false;
			}
			if (noticeArr.length > 0) {
				this.$util.showError(`${noticeArr.join(',')}中有未完成的题目，请完成后提交`);
				return false;
			}
			return true;
		}
	}
};
</script>

<style scoped>
.gaokao-nav {
	width: 100%;
	display: flex;
	align-items: center;
	padding: 20px 0;
}
.gaokao-nav span {
	font-size: 15px;
	color: #333;
	cursor: pointer;
}
.gaokao-nav span:hover {
	opacity: 0.7;
}
.gaokao-nav span:last-child {
	color: #333;
}
</style>
